<template>
    <v-dialog v-model="show" max-width="700" persistent no-click-animation>
        <div class="block-relative">
            <loading-inside-component v-if="dataLoading"></loading-inside-component>
            <!--Dialog-->
            <v-form v-model="formValid" ref="form" @submit="submit">
                <div class="CampaignAddCustomer">
                    <!--Header dialog-->
                    <div class="dialog-header">
                        <div>{{ $f.tc(model && model.id ? 'updateCustomer' : 'addCustomer') }}</div>
                        <v-btn small icon @click="close">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <!--Content dialog-->
                    <div class="dialog-content fci-scrollbar">
                        <div class="d-flex flex-wrap" style="gap: 8px">
                            <div style="width: 100%">
                                <div class="label">{{ $f.tc('name') }}</div>
                                <v-text-field
                                    v-model="model.name"
                                    :rules="checkRequiredName() ? formRules.required : []"
                                    class="input-custom"
                                ></v-text-field>
                            </div>
                            <div style="margin-top: 4px; width: 100%">
                                <div class="label">{{ $f.tc('phoneList') }}</div>
                                <v-text-field
                                    v-model="model.phone_numbers"
                                    :rules="[formRules.ruleRequired, rulePhoneList]"
                                    class="input-custom"
                                ></v-text-field>
                            </div>
                            <template v-if="attrs.length">
                                <div v-for="attr in attrs" :key="attr.key" style="margin-top: 4px; width: 46%">
                                    <div style="display: flex">
                                        <div class="label">{{ attr.title }}</div>
                                        <v-tooltip right v-if="attr.key && validateProperties[attr.key]">
                                            <template v-slot:activator="{ on }">
                                            <span v-on="on" class="detail-text">
                                                <v-icon color="#96ADD0" style="font-size: 16px; margin-left: 2px">mdi-information</v-icon>
                                            </span>
                                            </template>
                                            <li v-for="(valid,index) in validateProperties[attr.key]" :key="index">
                                                {{ attr.key }}
                                                {{ valid.operator ? valid.operator : '' }}
                                                {{ valid.threshold ? valid.threshold : '' }}
                                            </li>

                                        </v-tooltip>
                                    </div>
                                    <v-text-field
                                        v-model="attr.value"
                                        class="input-custom"
                                    ></v-text-field>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!--Footer dialog-->
                    <div class="dialog-footer">
                        <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
                        <div class="btn-outline ml-8" @click="close">{{ $f.tc('cancel') }}</div>
                    </div>
                </div>
            </v-form>
        </div>
    </v-dialog>
</template>
<script>
import LoadingInsideComponent from '@/components/LoadingInsideComponent'
import CampaignService from '@/services/campaign.service'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import {mapState} from 'vuex'
import _ from 'lodash'

const DEFAULT_MODEL = {
    id: null,
    name: '',
    phone_numbers: ''
}
export default {
    name: 'CampaignAddCustomer',
    mixins: [
        FormMixin
    ],
    components: {
        LoadingInsideComponent
    },
    data() {
        return {
            show: false,
            dataLoading: false,
            formValid: false,
            model: JSON.parse(JSON.stringify(DEFAULT_MODEL)),
            attrs: [],
            validateProperties: {}
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign,
            campaignConfig: state => state.campaign.campaignConfig
        })
    },
    methods: {
        isAGoodPhoneNumber(phoneNumber, regexPhoneNumber) {
            if (phoneNumber && regexPhoneNumber.test(phoneNumber)) {
                // good phoneNumber, continue to next phoneNumber
            } else if ((phoneNumber.substring(0, 2) === '62' || phoneNumber.substring(0, 3) === '+62' || phoneNumber.substring(0, 4) === '0062') && /^[0-9-+]{10,15}$/.test(phoneNumber)) {
                // INDO phoneNumber
            } else if ((phoneNumber.substring(0, 3) === '855' || phoneNumber.substring(0, 4) === '+855' || phoneNumber.substring(0, 5) === '00855') && /^[0-9-+]{10,15}$/.test(phoneNumber)) {
                // CAMPUCHIA phoneNumber
            } else if ((phoneNumber.substring(0, 3) === '856' || phoneNumber.substring(0, 4) === '+856' || phoneNumber.substring(0, 5) === '00856') && /^[0-9-+]{10,15}$/.test(phone)) {
                // LAO phoneNumber
            } else {
                return false
            }
            return true
        },
        rulePhoneList(v) {
            if (!v) {
                return this.$t('formRules.fieldNotValid', [this.$t('phoneNumber')])
            }
            let phoneList = v.split(';')
            let regexPhoneNumber = RegExp
            let invalidRegex = false
            try {
                regexPhoneNumber = new RegExp(this.campaign.regex_phone_number ? this.campaign.regex_phone_number : '^[0-9-+]{10,15}$')
            } catch (e) {
                invalidRegex = true
                regexPhoneNumber = /^[0-9-+]{10,15}$/
            }
            for (let phone of phoneList) {
                if (!this.isAGoodPhoneNumber(phone,regexPhoneNumber)){
                    return this.$f.tc('formRules.fieldNotValid', [this.$t('phoneNumber')])
                }
            }
            if (invalidRegex) {
                this.$appService.toastWarning('invalid regex, use default regex phone number')
            }
            return true
        },
        checkRequiredName() {
            if (this.campaignConfig) {
                return this.campaignConfig['required_customer_name']
            }
            return true
        },
        open(data) {
            this.show = true
            if (data) {
                this.dataLoading = true
                Promise.all([
                    CampaignService.getCustomer(this.campaign, data),
                    CampaignService.getCustomerProperties(this.campaign)
                ]).then(res => {
                    this.model = {...res[0]['data']}
                    if (res[1]['data'].length) {
                        this.prepareAttrs(res[1]['data'], this.model)
                    }
                    this.dataLoading = false
                    this.$nextTick().then(() => {
                        this.$refs.form.resetValidation()
                    })
                    let phone_numbers = ''
                    this.model.phone_numbers.map(phone => {
                        phone_numbers += phone.phone_number + ';'
                    })
                    this.model.phone_numbers = phone_numbers.substring(0, phone_numbers.length - 1)
                })
            } else {
                this.model = JSON.parse(JSON.stringify(DEFAULT_MODEL))
                CampaignService.getCustomerProperties(this.campaign).then(res => {
                    if (res.data.length) {
                        this.prepareAttrs(res.data)
                    }
                    this.$nextTick(() => {
                        this.$refs.form.resetValidation()
                    })
                })
            }
        },
        prepareAttrs(data, model) {
            data.map(item => {
                let obj = {
                    key: item.name,
                    title: item.description,
                    value: ''
                }
                if (model) {
                    obj.value = model[item.name + '']
                }
                this.attrs.push(obj)
            })
        },
        collectAttrs() {
            let obj = {}
            if (this.attrs.length) {
                this.attrs.map((attr, idx) => {
                    let key = this.attrs[idx]['key'].toString()
                    obj[key] = this.attrs[idx]['value']
                })
            }
            return obj
        },
        close() {
            this.show = false
            this.resetModel()
        },
        submit(event) {
            if (event) {
                event.preventDefault()
            }
            if (this.formValid) {
                this.dataLoading = true
                const i18n = {
                    action: this.model.id ? this.$t('update') : this.$t('create'),
                    item: this.$t('customer')
                }
                this.model = _.merge(this.model, this.collectAttrs())
                let phone_numbers = []
                let split = this.model.phone_numbers.split(';')
                for (let i in split) {
                    phone_numbers.push({
                        priority: i,
                        phone_number: split[i],
                        status: 'Not Attempted'
                    })
                }
                let model = {
                    ...this.model,
                    phone_numbers
                }
                let promise = this.model.id
                    ? CampaignService.editCustomer(this.campaign, model)
                    : CampaignService.addCustomer(this.campaign, model)
                promise.then(() => {
                    this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                    this.dataLoading = false
                    this.$emit('done')
                    this.close()
                }, () => {
                    this.dataLoading = false
                })
            } else {
                this.$refs.form.validate()
            }
        },
        resetModel() {
            if (this.$refs.form) {
                this.$refs.form.reset()
            }
            this.attrs = []
        }
    },
    watch: {
        campaignConfig: {
            deep: true,
            handler: function () {
                if (this.campaignConfig) {
                    this.validateProperties = this.campaignConfig.validate_customer_properties
                }
            }
        }
    },
    beforeDestroy() {
        this.resetModel()
    }
}
</script>
<style lang="scss" scoped>
.CampaignAddCustomer {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .btn-custom {
        margin-left: 8px;
        margin-right: 0 !important;
    }

    .label {
        margin-bottom: 2px !important;
        font-family: "open sans semi", serif;
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }

    .dialog-content {
        max-height: calc(85vh - 100px);
        overflow-y: auto;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}
</style>
